import { cva } from 'class-variance-authority';

import type { VariantProps } from 'class-variance-authority';
import type { FC, HTMLAttributes } from 'react';

import s from './CardWrapper.module.css';

const variants = cva(s.wrapper, {
  defaultVariants: {
    variant: 'neutral',
  },
  variants: {
    variant: {
      invert: s.variant_invert,
      neutral: s.variant_neutral,
      primary: s.variant_primary,
    },
  },
});

type CardWrapperProps = HTMLAttributes<HTMLDivElement> & VariantProps<typeof variants>;

const CardWrapper: FC<CardWrapperProps> = ({ className, variant, ...props }) => (
  <div className={variants({ className, variant })} {...props} />
);

export { CardWrapper, type CardWrapperProps };
